import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AppServiceService } from 'src/app/api/app-service.service';
import { OTPVerificationPage } from '../modals/otp-verification/otp-verification.page';
import { InputSelectModalComponent } from 'src/app/component/input-select-modal/input-select-modal.component';

@Component({
  selector: 'app-register',
  templateUrl: './register.page.html',
  styleUrls: ['./register.page.scss'],
})
export class RegisterPage implements OnInit {
  @Output() onRegistrationSuccess: EventEmitter<any> = new EventEmitter();
  @Output() onNavigatePages: EventEmitter<any> = new EventEmitter();
  // otp verifgication template for web view
  @ViewChild('otpVerification') otpVerificationTemp: TemplateRef<any>;

  /**
   *Registraion page variables
   */
  public showPassword = false;
  public showrepeatPassword = false;
  public value: any = {
    first_name: "",
    last_name: "",
    mobile_number: "",// "+4915751628517",
    email: "",
    password: "",
    confirm_password: "",
    tac: true,
    newsalert: false,
    isVerified: false,
    referred_by:'',
    company: '',
  }
  // public value: any = {
  //   first_name: "Kasun",
  //   last_name: "Sameera",
  //   mobile_number: "+4915751628517",// "+4915751628517",
  //   email: "pumayk.26@gmail.com",
  //   password: "123123Qq!",
  //   confirm_password: "123123Qq!",
  //   tac: true,
  //   newsalert: false,
  //   isVerified: false
  // }

  isRegisterInProgress: boolean = false;

  public lang: any = null;

  public isMobileRegistration: boolean = false;
  public mobileVerificationCodeSending: boolean = false;

  public passwordVisible: boolean = false;

  public isCartIconShowing: boolean = false;

  // OTP Verification Page Verification response object for web version
  public otpCodeResponse: { sentVia: string, userData: any, operationType: string } | null = null;

  constructor(public appService: AppServiceService, private router: Router, public translate: TranslateService,
    public route: ActivatedRoute, public modalController: ModalController) {

  }

  ngOnInit() {
    this.getLang();

    // check came for mobile registration or not
    if (this.route.snapshot.queryParams && this.route.snapshot.queryParams.mobile_registration) this.isMobileRegistration = true;

  }

  async register() {

    this.value['type'] = 'registered';
    this.value['newsalert'] = this.value['newsalert'] ? "true" : "false";

    this.isRegisterInProgress = true;

    if (this.appService.appObject.userVerificationRequired) {
      this.appService.appObject.errors = {};
      let validationResponse = await this.appService.requestValidation(this.value);
      // console.log('validationResponse : ' , validationResponse);
      if (validationResponse.status) {
        let verificatioData = { mobile_number: this.value.mobile_number, email: this.value.email };
        // request verification code, will check in backend for the method mobile / email and send back the method
        this.appService.requestVerificationCode(verificatioData).then(async (verificationResponse) => {
          // if verification code has been sent, will return the what method used to sent 
          if (verificationResponse.status) {
            this.appService.startVerificationCodeIntervalCountdown();

            if (this.appService.isWebVersion) {
              verificationResponse.userData = this.value;
              verificationResponse.operationType = 'registration';
              this.otpCodeResponse = verificationResponse;
              // this.onVerificationCodeSent.emit(verificationResponse);

              const modal = await this.modalController.create({
                component: InputSelectModalComponent,
                cssClass: 'select-modal',
                componentProps: {
                  content: this.otpVerificationTemp,
                  hideFooter: true
                },
              });

              modal.present();

              modal.onDidDismiss().then(async (otpResponse) => {
                console.log('otpResponse : ', otpResponse);
                this.onRegistrationOTPVerificationResponse(otpResponse);
              });

            } else {
              // open otp verification popup
              const cartModal = await this.modalController.create({
                component: OTPVerificationPage,
                cssClass: 'custom-popup',
                componentProps: {
                  userData: this.value,
                  operationType: 'registration',
                  previousCodeSentVia: verificationResponse.sentVia
                }
              });

              await cartModal.present();
              // on dismiss check returned data 
              cartModal.onDidDismiss().then((response: any) => {
                this.onRegistrationOTPVerificationResponse(response);
              });
            }
          }
        })
      } else {
        // when submit form data, this boolean value changed to string true / false. reverse it when cancel process
        if (this.value['newsalert']) {
          this.value['newsalert'] = this.value['newsalert'] === 'true' ? true : false;
        }
        this.appService.appObject.errors = this.appService.getErrorArray(validationResponse.msg);
        this.isRegisterInProgress = false;

        // console.log(this.appService.appObject.errors);

      }
    } else { // else normal registration process
      this.userRegistration();
    }
  }

  /**
   * Will trigger when user verify otp in registartion process
   * and after submiting otp, once response arrive this will call
   * moved to a seperated function coz reuse the same code
   * @param response response from otp verification
   */
  onRegistrationOTPVerificationResponse(response) {
    if (response.data && response.data.isVerified) {
      this.value.isVerified = true;
      this.userRegistration();
    } else {
      this.isRegisterInProgress = false;
      // when submit form data, this boolean value changed to string true / false. reverse it when cancel process
      if (this.value['newsalert']) {
        this.value['newsalert'] = this.value['newsalert'] === 'true' ? true : false;
      }
    }
  }

  /**
   * registration process splited into two separate functions due to the verification process implementation
   */
  async userRegistration() {
    await this.appService.register_from_email(this.value, true);
    this.isRegisterInProgress = false;
    if (this.appService.appObject.errors && Object.keys(this.appService.appObject.errors).length) {
      this.displayFormErrors();
    } else if (this.appService.registrationServerError) {
      this.appService.showToast('Something went wrong', 'danger');
    } else {
      await this.appService.getUserDetails({ 'customer_id': this.appService.appObject.userId });
      if (this.appService.isWebVersion) {
        // if registration was success then call callback function
        this.onRegistrationSuccess.emit();
      } else {
        if (this.appService.isWhileRequestingPostalCode) {
          this.router.navigate(['home'], { queryParams: { requestPostalCode: true } });
        } else if (this.appService.isWhileRequestingNewPostalCode) {
          this.router.navigate(['home'], { queryParams: { requestNewPostalCode: true } });
        } else {
          this.appService.navigateToRegisterd();
        }
      }
    }
  }

  /**
   * This will extract form errors from ashan's stupit error object in appObject :/ stupidity level 99999
   * Moved to separate function from register function body to reuse
   */
  displayFormErrors() {
    let first = '';
    for (var key in this.appService.appObject.errors) {
      if (first == '') {
        first = key;
      }
    }

    switch (first) {
      case 'first_name':
        document.getElementById("first-name").focus();
        break;
      case 'last_name':
        document.getElementById("last-name").focus();
        break;
      case 'mobile_number':
        document.getElementById("telephone").focus();
        break;
      case 'email':
        document.getElementById("email").focus();
        break;
      case !this.isMobileRegistration && 'password':
        document.getElementById("password").focus();
        break;
      case !this.isMobileRegistration && 'confirm_password':
        document.getElementById("confirm_password").focus();
        break;

    }
  }

  togglePassword(input) {
    input.type = input.type === 'password' ? 'text' : 'password';
  }

  emailvalidation() {
    if (this.value.email) {
      this.value.email = this.value.email.trim();
    }
  }

  /**
   * This will redirect user to given route
   * @param location string value of route path
   */
  async navigateTo(slug) {
    if (!this.appService.isWebVersion)
      this.router.navigate([slug === 'tnc' ? '/pages/tnc' : '/pages/pnp'])
    else {
      this.onNavigatePages.emit([slug]);
    }
  }

  ionViewDidEnter() {
    if (this.appService.appObject.isAuthed) {
      if (this.appService.isWebVersion)
        this.router.navigate(['home']);
      else
        this.router.navigate(['home']);
    }

    setTimeout(() => {
      this.isCartIconShowing = this.appService.hideCartButton;
      this.appService.hideCartButton = true;
    }, 200);
  }

  ionViewDidLeave() {
    this.appService.hideCartButton = this.isCartIconShowing;
  }

  /**
   * 
   * get languages
   */
  async getLang() {
    await this.translate.get('key').subscribe(
      value => {
        this.lang = value;
      }
    )
  }

}
